import { DatapointValueTypeEnum } from "api/ux/src";
import { convertToEsgIndexOrNumber } from "common/esg-helpers";
export const mapRepRiskRatingToItsNumber = (field) => (args, d) => {
    const dp = d.datapoints?.filter((di) => di.name === field)?.[0];
    if (dp) {
        const newItem = { ...d, datapoints: d.datapoints?.filter((di) => di.name !== field) };
        newItem.datapoints?.push({
            name: field,
            type: DatapointValueTypeEnum.Number,
            value: convertToEsgIndexOrNumber(dp.value?.toString())
        });
        return newItem;
    }
    return d;
};
